import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Loader } from "./components/CoreUI";
import Banner from "./components/Banner";
import OrderConfirmation from "./components/OrderConfirmation";
// import SurveyCard from "./components/Cards/SurveyCard";
import WidgetCard from "./components/WidgetCard";
import useResource from "./hooks/useResource";
import message from "./utils/message";
import { eventTypes } from "./hooks/useTrack";
import GET from "./utils/GET";
import getApiUrl from "./utils/getApiUrl";
import calcUserRewardPoints from "./utils/calcUserRewardPoints";
import { AnimatePresence } from "framer-motion";
// import SurfaceOverlay from "./components/SurfaceOverlay";
// import OfferCard from "./components/Cards/OfferCard";
import { rewardClaimUrl } from "./conf";
import inFullscreen from "./utils/inFullscreen";
import calcColorContrast from "./utils/calcColorContrast";
// import OfferPreview from "./components/Previews/OfferPreview";
import DesktopOverlay from "./components/DesktopOverlay";
import ProductView from "./components/ProductView";
import TrackerWrapper from "./components/TrackerWrapper";

import PlatformPreview from "./components/Previews/PlatformPreview";
import ModulesPreview from "./components/Previews/ModulesPreview";
import SurfaceManger from "./components/SurfaceManager";
import uuid from "./utils/uuid";

// import { testProd } from "./conf";
const testPublisher = "bfb23361-2141-4a72-aba2-803a5c27dbed";

// PREVIEW'S FOR THE PLATFORM
const platform = GET("platform");

const inTestmode = GET("testmode");

const full = GET("full");
const fullPreviewType = GET("fullPreviewType");
const fullPreviewID = GET("fullPreviewID");

const selfPreview = GET("selfPreview");
const ppePreview = GET("ppePreview");
const upsellsPreview = GET("upsellsPreview");
const crossSellPreview = GET("crossSellPreview");
const crossSellProductsPreview = GET("crossSellProductsPreview");

const surveyPreview = GET("surveyPreview");
const offerPreview = GET("offerPreview");
const rewardsPreview = GET("rewardsPreview");
const flowPreview = GET("flowPreview");
const customOfferPreview = GET("customOfferPreview");
const customSurveyPreview = GET("customSurveyPreview");
const customPostPreview = GET("customPostPreview");

const overlayPreview =
	surveyPreview ||
	offerPreview ||
	rewardsPreview ||
	flowPreview ||
	// customOfferPreview ||
	false;

const customOverlayPreview =
	customOfferPreview || customSurveyPreview || customPostPreview || false;

const isModalWidget = GET("modal");
// ---------------------
const parseCopy = (text, name) => {
	if (text.indexOf("{BRAND_NAME}") === -1) {
		return text;
	}
	return text.replace("{BRAND_NAME}", name);
};

// Get GET params
const cost = GET("cost");
const live = GET("live");
const email = GET("email");
const contactEmail = GET("contactEmail");

// const InnerWidth = GET("innerWidth");
const identifier = GET("identifier");
const userName = GET("name");
const desktopOverlay = GET("desktopOverlay");
const shopifyOrderID = GET("shopifyOrderID");
const shopifyDiscountCode = GET("shopifyDisCo");
const ship = GET("ship");
const shopifyToken = GET("token");
let purchases = GET("purchases");
let publisher = GET("publisher");

// Process GET params
if (publisher) {
	try {
		purchases = JSON.parse(purchases);
	} catch (error) {
		purchases = false;
	}
}

const originalPublisher = publisher;
if (!publisher) {
	publisher = testPublisher;
}

// Get final Endpoint
const url = publisher
	? getApiUrl() +
	  (selfPreview ? `/core/self/${publisher}/` : `/core/push/${publisher}/`)
	: false;

const userPoints = calcUserRewardPoints();
const rewardResponse = {
	method: "POST",
	body: JSON.stringify({
		email: email,
		first_name: userName,
		earned_points: userPoints,
	}),
	headers: {
		"Content-Type": "application/json",
	},
};

function App({ test, testData }) {
	const [widgetState, setWidgetState] = useState("max");
	const [displaySurfaceModal, setDisplaySurfaceModal] = useState(true);
	// const [displaySurveyInline, setDisplaySurveyInline] = useState(true);
	// const [modalSurveyAnswer, setModalSurveyAnswer] = useState(-1);
	const [pageLoadFired, setPageLoadFired] = useState(false);
	const [minimizePPE, setMinimizePPE] = useState(false);

	// const [pdpInfo, setPdpInfo] = useState(testProd);
	const [pdpInfo, setPdpInfo] = useState(false);
	const [offsetTop, setOffsetTop] = useState(0);
	const [innerHeight, setInnerHeight] = useState(
		GET("innerHeight") || window.innerHeight
	);

	const formData = useMemo(() => {
		const formData = new FormData();

		formData.set("url", GET("host"));
		if (cost) {
			formData.set("c", cost);
		}
		if (email) {
			formData.set("e", email);
		}
		if (purchases) {
			formData.set("p", JSON.stringify(purchases));
		}

		if (live) {
			formData.set("live", "true");
		}

		if (ship) {
			formData.set("shipping_method", "true");
		}

		if (upsellsPreview) {
			formData.set("upsells", "true");
		}
		if (crossSellPreview) {
			formData.set("cross_sell", "true");
		}
		if (crossSellProductsPreview) {
			formData.set("cross_sell_products", "true");
		}

		if (platform) {
			formData.set("platform", "true");
		}

		if (full) {
			formData.set("full", "true");
		}
		if (fullPreviewType) {
			formData.set("full_preview_type", fullPreviewType);
		}
		if (fullPreviewID) {
			formData.set("full_preview_id", fullPreviewID);
		}

		if (overlayPreview) {
			if (surveyPreview) {
				formData.set("surveyPreview", "true");
			}
			if (offerPreview) {
				formData.set("offerPreview", "true");
			}
			if (rewardsPreview) {
				formData.set("rewardsPreview", "true");
			}
		}

		if (shopifyOrderID) {
			formData.set("shopify_order_id", shopifyOrderID);
		}
		formData.set("shopify_discount_code", shopifyDiscountCode);
		formData.set("shopify_checkout_token", shopifyToken);
		formData.set("identifier", identifier);
		return formData;
	}, []);

	let [{ loading, error, data }, loadData] = useResource(
		url,
		{
			method: "POST",
			body: formData,
		},
		false
	);

	const [, triggerRewardResponse, , setRewardResponseOptions] = useResource(
		rewardClaimUrl,
		rewardResponse,
		false
	);

	useEffect(() => {
		if (
			!loading &&
			data &&
			(widgetState === "min" ||
				isModalWidget ||
				!inFullscreen ||
				(data.display_order && data.display_order.length === 0))
		) {
			setDisplaySurfaceModal(false);
		}
	}, [widgetState, loading, data]);

	if (test) {
		data = testData;
	}

	const handleClose = useCallback(() => {
		setDisplaySurfaceModal(false);
	}, [setDisplaySurfaceModal]);

	const callRewardApi = useCallback(
		(value = false) => {
			if (!value) {
				return triggerRewardResponse();
			}
			const updatedResponse = {
				...rewardResponse,
				body: JSON.stringify({
					...JSON.parse(rewardResponse.body),
					email: value,
					order_id: identifier,
				}),
			};
			setRewardResponseOptions(updatedResponse);
			triggerRewardResponse();
		},
		[setRewardResponseOptions, triggerRewardResponse]
	);
	useEffect(() => {
		if (!originalPublisher) {
			console.error(
				`No publisher found in GET params. Using Testing publisher: ${testPublisher} `
			);
		}
		// message()
		if (
			!test &&
			!desktopOverlay &&
			!overlayPreview &&
			!customOverlayPreview
		) {
			loadData();
		}
		window.addEventListener("resize", () => message());
		return () => window.removeEventListener("resize", () => message());
	}, [loadData, test]);

	useEffect(() => {
		window.addEventListener("message", ({ data: scriptData }) => {
			if (scriptData === "max" || scriptData === "min") {
				return setWidgetState(scriptData);
			}
			if (scriptData.type === "REWARDS_CLAIM") {
				callRewardApi(scriptData.email);
			}
			if (scriptData.type === "WINDOW_HEIGHT_CHANGE") {
				setInnerHeight(scriptData.data);
			}
			// if (scriptData.type === "DESKTOP_OVERLAY_CLOSE") {
			// const { key, length } = scriptData.data;
			// handleClose(key, length);
			// 	message();
			// }
			if (scriptData.type === "scroll") {
				const { scrollTop } = scriptData;
				setOffsetTop(scrollTop);
			}
		});
	}, [setWidgetState, callRewardApi, handleClose]);

	useEffect(() => {
		if (!data || !data.publisher_details) {
			return;
		}
		if (!loading && data && !pageLoadFired) {
			const copy =
				data.publisher_details && data.publisher_details.copy_object;

			const rewards =
				data.display_order &&
				data.display_order.find(
					(item) => item.field_name === "rewards"
				);

			message({
				type: "LOAD_COMPLETE",
				text: copy
					? parseCopy(copy.text, data.p)
					: "Get exclusive access to products you'll love 😎",
				bigButton: copy && copy.button_id === 1,
				ppe: data.publisher_details.post_purchase,
				rewardsDisabled: !rewards,
				points: rewards && rewards.rewards.total_points,
				optedIn: rewards && rewards.rewards.opted_in,
				premium: data?.publisher_details?.is_premium,
				brandColor:
					data &&
					data.publisher_details &&
					data.publisher_details.modal_color,
				brandColorText:
					data &&
					data.publisher_details &&
					data.publisher_details.modal_color
						? calcColorContrast(data.publisher_details.modal_color)
							? "var(--text)"
							: "#fff"
						: "",
			});

			const loadMetadata = (data && data.load_metadata) || {};
			const allProperties = {
				userId: data ? data.u : null,
				publisher,
				categories: data && data.c ? data.c : [],
				publisher_name: data ? data.p : null,
				coop_session: GET("uid") ? GET("uid") : data ? data.s : null,
				shipping_id: GET("shippingId"),
				billing_id: GET("billingId"),
				customer_id: GET("customerId"),
				created_at: GET("createdAt"),
				order_id: GET("identifier") || "",
				shopify_order_id: GET("shopifyOrderID") || "",

				userName: userName ? userName : "",
				post_purchase:
					data &&
					data.publisher_details &&
					data.publisher_details.post_purchase,
				survey:
					data &&
					data.publisher_details &&
					data.publisher_details.survey,
				upsell:
					(data &&
						data.self_products &&
						data.self_products.products &&
						data.self_products.products.length > 0) ||
					false,
				url: window.location.href,
				host: GET("host"),
				coop_event_id: uuid(),
				contact_email: contactEmail,
				cost,
				purchases,
				...loadMetadata,
			};
			if (test || platform || desktopOverlay) {
				return;
			}
			if (!platform && !full && window?.analytics && !inTestmode) {
				window.analytics.track(eventTypes.PAGE_LOAD, allProperties);
				console.log("[ FIRED ] ", eventTypes.PAGE_LOAD);
			}
			setPageLoadFired(true);
		}
		if (data.publisher_details.post_purchase && inFullscreen) {
			message("MAXIMIZE");
		} else {
			message("MINIMIZE");
		}
	}, [loading, data, pageLoadFired, test]);

	useEffect(() => {
		return message();
	}, [widgetState]);

	// const surveyQuestion = useMemo(() => {
	// 	if (!data || !data.display_order) {
	// 		return false;
	// 	}
	// 	const surveyData = data.display_order.find(
	// 		(mod) => mod.field_name === "survey"
	// 	);
	// 	if (surveyData) {
	// 		return surveyData.survey_question;
	// 	}
	// 	return false;
	// }, [data]);

	// const offerData = useMemo(() => {
	// 	if (!data || !data.display_order) {
	// 		return false;
	// 	}
	// 	const offerData = data.display_order.find(
	// 		(mod) => mod.field_name === "offer"
	// 	);
	// 	if (offerData) {
	// 		return offerData;
	// 	}
	// 	return false;
	// }, [data]);

	const handleMinimizePPE = useCallback((value) => setMinimizePPE(value), []);

	useEffect(() => {
		if (pdpInfo) {
			message({
				type: "OPEN_PDP",
			});
		} else {
			message({
				type: "CLOSE_PDP",
			});
		}
	}, [pdpInfo]);

	return (
		<>
			<AnimatePresence>
				{!desktopOverlay && !overlayPreview && !customOverlayPreview && (
					<TrackerWrapper data={data} test={test}>
						{loading && <Loader center />}
						{(data || error) && (
							<>
								{((widgetState === "max" &&
									// !overlayPreview &&
									// !surveyPreview &&
									!selfPreview &&
									// data &&
									// data.publisher_details &&
									data?.publisher_details?.post_purchase) ||
									ppePreview) && (
									<>
										<Banner
											name={data && data.p ? data.p : ""}
											details={
												data && data.publisher_details
													? data.publisher_details
													: {
															logo_url: "",
															single_liner: "",
															banner_url: "",
													  }
											}
											minimizePPE={minimizePPE}
										/>
										<OrderConfirmation
											publisher={data.publisher_details}
										/>
									</>
								)}
								{/* {data && offerData && offerPreview && platform ? (
							offerData.active ? (
								<OfferCard
									data={data}
									modalData={offerData}
									onClose={() => {}}
								/>
							) : (
								<StatusLabel>
									Please make an offer active to see it's
									preview
								</StatusLabel>
							)
						) : (
							<></>
						)} */}
								{/* {data &&
									data.publisher_details &&
									data.publisher_details.survey &&
									surveyQuestion &&
									Object.keys(surveyQuestion).length !== 0 &&
									((displaySurveyInline &&
										!platform &&
										!surveyPreview) ||
										(platform && surveyPreview)) && (
										<SurveyCard
											publisher={data.p}
											survey={surveyQuestion}
											customerID={data.u}
											modalAnswer={modalSurveyAnswer}
											modalVisible={displaySurfaceModal}
										/>
									)} */}
								{/* {!surveyPreview && ( */}
								{/* {!overlayPreview && ( */}
								<WidgetCard
									error={error}
									publisher={publisher}
									cost={cost}
									purchases={purchases}
									brands={data && data.l ? data.l : []}
									data={data}
									// offerData={offerData}
									modalVisible={displaySurfaceModal}
									onAnimationComplete={() => message()}
									setMinimizePPE={handleMinimizePPE}
									setPdpInfo={setPdpInfo}
									widgetState={widgetState}
								/>
								{/* )} */}
								<AnimatePresence>
									{pdpInfo && (
										<ProductView
											pdpInfo={pdpInfo}
											innerHeight={innerHeight}
											setPdpInfo={setPdpInfo}
											offsetTop={offsetTop}
										/>
									)}
									{displaySurfaceModal &&
										// data &&
										// (!platform ||
										// 	(platform &&
										// 		overlayPreview &&
										// 		!customOfferPreview)) &&
										widgetState === "max" &&
										// data.publisher_details &&
										(data?.publisher_details
											?.post_purchase ||
											full) &&
										data?.display_order?.length > 0 &&
										inFullscreen &&
										!isModalWidget && (
											<SurfaceManger
												data={data}
												onClose={handleClose}
												rewardResponseTrigger={
													callRewardApi
												}
												innerHeight={innerHeight}
												offsetTop={offsetTop}
											/>
										)}
								</AnimatePresence>
							</>
						)}
					</TrackerWrapper>
				)}
				{desktopOverlay && (
					<DesktopOverlay
						callRewardApi={callRewardApi}
						innerHeight={innerHeight}
						offsetTop={offsetTop}
					/>
				)}
				{platform && overlayPreview && (
					<PlatformPreview
						callRewardApi={callRewardApi}
						innerHeight={innerHeight}
						offsetTop={offsetTop}
					/>
				)}
				{platform && customOverlayPreview && (
					<ModulesPreview
						innerHeight={innerHeight}
						offsetTop={offsetTop}
					/>
				)}
			</AnimatePresence>
		</>
	);
}

export default App;
